// extracted by mini-css-extract-plugin
export var aboveInput = "_ij-0";
export var actionButton = "_ij-5";
export var actionButtonContainer = "_ij-1";
export var actionIcon = "_ij-6";
export var aiInfoContainer = "_ij-2";
export var attachmentWrapper = "_ij-7";
export var bold = "_ij-3";
export var checkIcon = "_ij-8";
export var clickingRecipientBar = "_ij-11";
export var commentThreadSwitch = "_ij-a";
export var draftImage = "_ij-b";
export var draftImageContainer = "_ij-c";
export var draftImages = "_ij-e";
export var editButton = "_ij-g";
export var editor = "_ij-f";
export var editorContainer = "_ij-y";
export var editorErrorTooltipWrapper = "_ij-9";
export var headerDivider = "_ij-h";
export var icon = "_ij-i";
export var info = "_ij-j";
export var internal = "_ij-n";
export var internalDivider = "_ij-k";
export var internalMessage = "_ij-l";
export var messageInputCard = "_ij-m";
export var messageInputForm = "_ij-o";
export var messageInputFormInternal = "_ij-p";
export var options = "_ij-q";
export var publicMessageCustomer = "_ij-s";
export var publicMessageMerchant = "_ij-r";
export var removeImageButton = "_ij-d";
export var replyButtons = "_ij-t";
export var showSignatureButton = "_ij-u";
export var spinner = "_ij-v";
export var verticalButtonDivider = "_ij-4";
export var visibilitySelector = "_ij-w";
export var warning = "_ij-x";
export var wrappingText = "_ij-z";
export var writingInternalNoteTopBorder = "_ij-10";